export interface IPromocionDataPagingResponse {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: IPromocion[];
}

export interface IPromocion {
  id_promocion?: string;

  nombre: string;
  codigo: string;

  tipo_descuento: string;
  valor_descuento: string;

  prioridad: number;

  // Arrays codes/*
  paises: string[]; // fk
  provincias: string[]; // fk
  ciudades: string[]; // fk
  parroquias: string[]; // fk
  zonas: string[]; // fk
  sectores: string[]; // fk
  planes: string[]; // fk
  centros_costo: string[]; // fk
  canales_venta: string[]; // fk
  meses_descuento: string[]; // libre
  meses_gratuitos: string[]; // libre

  // others
  recurrencia: string; // choice

  fecha_inicio: string;
  fecha_fin: string;
  // indefinido: boolean;

  aplicar_base: boolean;
  aplicar_total: boolean;
  estado: boolean;

  fecha_creacion?: string;
  fecha_modificacion?: string;
  numero_referencia?: string;
}



/* OLD
export interface IPromocion {
  id_promocion?: string;

  nombre: string;
  descripcion: string;
  fecha_inicio: string;
  fecha_fin: string;
  estado: boolean;

  codigo: string; // unique

  tipo_descuento: string; // no fk - radio button
  porcentaje_descuento: string; // number
  descuento_precio: string; // number

  cantones: string; // ciudad JSON []
  zonas: string; // JSON []
  sectores: string; // JSON []
  tipos_servicio: string; // JSON []
  planes: string; // JSON []
  metodos_pago: string; // JSON [] // forma_pago
  centros_costo: string; // JSON []
  canales_venta: string; // JSON []
  tipos_cliente: string; // JSON []
  prioridad: number;
  cuotas: string; // JSON - select de arr quemado
  meses_gratuitos: string; // JSON - select de arr quemado

  indefinido: boolean;

  ///* fk
  recurrencia: string; // name
  // recurrencia: Nullable<Recurrencia>;
}*/

export enum TipoDescuento {
  PORCENTAJE = 'PORCENTAJE',
  PRECIO = 'VALOR',
}

export enum PromocionesCodeEnum {
  PLAN_FAMILYMAX = 'P_PFM', // $15 CODIGO DE LA PROMCION
  CODIGO_PLAN_PLAN_FAMILYMAX = 'PFMX', //CODIGO DEL PLAN
}
